// Gold rule divider with heart motif. Three variants match the three dividers
// visible in the reference invitation photo:
//   - 'double-heart' (default): two gold rules flanking an outlined heart
//   - 'single-heart': one short rule + a small filled heart
//   - 'gold-rule': a single gradient rule with no heart
//
// Pure chrome — decorative only.
const RULE_BASE = 'h-px w-16 bg-gradient-to-r from-transparent via-gold/70 to-transparent';

function HeartIcon({ size = 16 }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden="true"
      className="text-gold"
    >
      <path
        d="M12 21s-7.5-4.6-9.5-9.2C1.1 8 3.4 4.5 7 4.5c2 0 3.4 1 5 3 1.6-2 3-3 5-3 3.6 0 5.9 3.5 4.5 7.3C19.5 16.4 12 21 12 21z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function Divider({ variant = 'double-heart', className = '' }) {
  if (variant === 'gold-rule') {
    return (
      <div
        aria-hidden="true"
        className={`mx-auto my-6 ${RULE_BASE} ${className}`}
      />
    );
  }
  if (variant === 'single-heart') {
    return (
      <div
        aria-hidden="true"
        className={`mx-auto my-4 flex w-32 items-center justify-center gap-2 text-gold ${className}`}
      >
        <span className={`${RULE_BASE} w-10`} />
        <HeartIcon size={10} />
      </div>
    );
  }
  return (
    <div
      aria-hidden="true"
      className={`mx-auto my-6 flex w-56 items-center justify-center gap-3 text-gold ${className}`}
    >
      <span className={RULE_BASE} />
      <HeartIcon size={16} />
      <span className={RULE_BASE} />
    </div>
  );
}
